const CONCESSIONS = 'concessions-pos'
const KIOSK = 'kiosk'
const SUITES = 'suites-pos'
const TABS = 'tabs-pos'

const DISPLAY_NAMES = {
  [CONCESSIONS]: 'Concessions POS',
  [KIOSK]: 'Kiosk',
  [SUITES]: 'Suites POS',
  [TABS]: 'Tabs POS',
}

const PRINTING_TYPES = {
  [CONCESSIONS]: 'pos',
  [KIOSK]: 'kiosk',
  [SUITES]: 'pos',
  [TABS]: 'pos',
}

const RECEIPT_TYPES = {
  [CONCESSIONS]: 'receipt',
  [KIOSK]: 'receipt',
  [SUITES]: 'suite-receipt',
  [TABS]: 'receipt',
}

const SINGLE_MENU_TYPES = [CONCESSIONS, TABS]

class DeviceSubtypes {
  static all = [CONCESSIONS, KIOSK, SUITES, TABS]
  static displayName = (type) => DISPLAY_NAMES[type]
  static isConcessions = (type) => type === CONCESSIONS
  static isKiosk = (type) => type === KIOSK
  static isSuites = (type) => type === SUITES
  static isTabs = (type) => type === TABS
  static isSuitesOrTabs = (type) => [SUITES, TABS].includes(type)
  static isSingleMenu = (type) => SINGLE_MENU_TYPES.includes(type)
  static printerDeviceType = (type) => PRINTING_TYPES[type]
  static printerReceiptType = (type) => RECEIPT_TYPES[type]
}

export default DeviceSubtypes
